export const story = {
  hero: {
    title: 'Worn out? Come to Jesus.',
    sub: 'He gives rest. Not a trick. A Person.',
    scripture: {
      ref: 'Matthew 11:28-30 (KJV)',
      lines: [
        'Come unto me, all ye that labour and are heavy laden, and I will give you rest.',
        'Take my yoke upon you, and learn of me; for I am meek and lowly in heart:',
        'and ye shall find rest unto your souls.',
        'For my yoke is easy, and my burden is light.',
      ],
    },
  },
  weight: {
    title: 'Name the weight.',
    lines: [
      'Bills stack up.',
      'News hits hard.',
      'Shame whispers at night.',
      'You try. You fail. You hide.',
      'You feel empty.',
    ],
    scriptures: [
      {
        ref: 'Romans 3:23 (KJV)',
        lines: ['For all have sinned, and come short of the glory of God;'],
      },
      {
        ref: 'Romans 6:23 (KJV)',
        lines: ['For the wages of sin is death; but the gift of God is eternal life through Jesus Christ our Lord.'],
      },
    ],
  },
  gospel: {
    title: 'The gospel in one paragraph.',
    summary: 'Jesus lived without sin, died for our sins, was buried, and rose on the third day. He did what we could not. He carries what we cannot. Turn and trust Him.',
    scriptures: [
      {
        ref: '1 Corinthians 15:1-4 (KJV)',
        lines: [
          'Moreover, brethren, I declare unto you the gospel which I preached unto you,',
          'which also ye have received, and wherein ye stand;',
          'By which also ye are saved, if ye keep in memory what I preached unto you,',
          'unless ye have believed in vain.',
          'For I delivered unto you first of all that which I also received,',
          'how that Christ died for our sins according to the scriptures;',
          'And that he was buried, and that he rose again the third day according to the scriptures:',
        ],
      },
    ],
  },
  solvable: {
    title: 'Jesus carries what you cannot.',
    line: 'He lived without sin. He died for sinners. He rose again.',
  },
  whoJesus: {
    title: 'Who Jesus is.',
    lines: [
      'Jesus is fully God and fully man.',
      'He did no sin.',
      'He took our place.',
    ],
    scriptures: [
      {
        ref: 'Colossians 2:9 (KJV)',
        lines: ['For in him dwelleth all the fulness of the Godhead bodily.'],
      },
      {
        ref: 'John 1:14 (KJV)',
        lines: [
          'And the Word was made flesh, and dwelt among us, (and we beheld his glory,',
          'the glory as of the only begotten of the Father,) full of grace and truth.',
        ],
      },
      {
        ref: '1 Peter 2:22 (KJV)',
        lines: ['Who did no sin, neither was guile found in his mouth:'],
      },
      {
        ref: 'John 1:12 (KJV)',
        lines: [
          'But as many as received him, to them gave he power to become the sons of God,',
          'even to them that believe on his name:',
        ],
      },
    ],
  },
  cross: {
    title: 'The cross and the empty tomb.',
    lines: [
      'Sin against the Holy God demands real payment.',
      'Either we pay forever... or Christ pays once.',
      'The cross paid it.',
      'The resurrection proved it.',
    ],
    scriptures: [
      {
        ref: '1 Corinthians 15:54-55 (KJV)',
        lines: [
          'So when this corruptible shall have put on incorruption, and this mortal shall have put on immortality,',
          'then shall be brought to pass the saying that is written, Death is swallowed up in victory.',
          'O death, where is thy sting? O grave, where is thy victory?',
        ],
      },
    ],
  },
  freeGift: {
    title: 'The free gift.',
    lines: [
      'You cannot earn this.',
      'Jesus gives it.',
    ],
    scriptures: [
      {
        ref: 'Romans 5:15 (KJV)',
        lines: [
          'But not as the offence, so also is the free gift. For if through the offence of one many be dead,',
          'much more the grace of God, and the gift by grace, which is by one man, Jesus Christ, hath abounded unto many.',
        ],
      },
      {
        ref: 'Ephesians 2:8-9 (KJV)',
        lines: [
          'For by grace are ye saved through faith; and that not of yourselves: it is the gift of God:',
          'Not of works, lest any man should boast.',
        ],
      },
      {
        ref: 'Romans 1:16 (KJV)',
        lines: [
          'For I am not ashamed of the gospel of Christ: for it is the power of God unto salvation to every one that believeth;',
          'to the Jew first, and also to the Greek.',
        ],
      },
    ],
  },
  pyramid: [
    {
      key: 'cross',
      title: 'The Cross',
      body: 'Sin against the Holy God demands real payment. The cross paid it.',
      scripture: '1 Corinthians 15:3-4 (KJV)',
    },
    {
      key: 'tomb',
      title: 'The Empty Tomb',
      body: 'The resurrection proved it. Death is swallowed up in victory.',
      scripture: '1 Corinthians 15:54-55 (KJV)',
    },
    {
      key: 'gift',
      title: 'The Free Gift',
      body: 'You cannot earn this. Jesus gives it.',
      scripture: 'Ephesians 2:8-9 (KJV)',
    },
  ],
  respond: {
    title: 'How to respond.',
    sub: 'Turn and trust - right now.',
    steps: [
      'Turn from sin. Tell the truth to God.',
      'Trust Jesus. Lean your whole weight on Him - His cross, His empty tomb.',
      'Ask Him. He loves to save the weary.',
    ],
    prayerTitle: 'Guiding prayer (not magic words):',
    prayer: "Jesus, I'm tired and guilty. I turn from my sin. I trust You - Your cross and Your empty tomb. Take my sin. Give me Your life. I want to follow You. Amen.",
    scriptures: [
      {
        ref: 'Romans 10:9 (KJV)',
        lines: [
          'That if thou shalt confess with thy mouth the Lord Jesus, and shalt believe in thine heart',
          'that God hath raised him from the dead, thou shalt be saved.',
        ],
      },
      {
        ref: '1 John 1:9 (KJV)',
        lines: ['If we confess our sins, he is faithful and just to forgive us our sins, and to cleanse us from all unrighteousness.'],
      },
      {
        ref: 'Titus 3:5 (KJV)',
        lines: [
          'Not by works of righteousness which we have done, but according to his mercy he saved us,',
          'by the washing of regeneration, and renewing of the Holy Ghost;',
        ],
      },
      {
        ref: 'Mark 9:24 (KJV)',
        lines: ['And straightway the father of the child cried out, and said with tears, Lord, I believe; help thou mine unbelief.'],
      },
    ],
  },
  whatChanges: {
    title: 'What changes.',
    lines: [
      'Today: Forgiven. Adopted. New heart. New power to fight sin.',
      'This week: Learn His voice in the Word. Pray. Find a church family.',
      'Long haul: Hard things may stay hard. Jesus stays close every time.',
    ],
    scripture: {
      ref: 'Matthew 11:28-30 (KJV)',
      lines: [
        'Come unto me, all ye that labour and are heavy laden, and I will give you rest.',
        'Take my yoke upon you, and learn of me; for I am meek and lowly in heart:',
        'and ye shall find rest unto your souls.',
        'For my yoke is easy, and my burden is light.',
      ],
    },
  },
  firstSteps: {
    title: 'First steps (next 7 days).',
    days: [
      'Day 1: Read Mark 1.',
      "Day 2: Pray 5 minutes. Use the Lord's Prayer.",
      'Day 3: Tell one trusted friend.',
      'Day 4: Find a Bible-teaching church.',
      'Day 5: Memorize Matthew 11:28.',
      'Day 6: Confess one known sin to God.',
      'Day 7: Ask about baptism at a local church.',
    ],
    toolsTitle: 'Helpful links and tools',
    tools: [
      { label: '1-Tap Reading Plan (Mark)', href: '#mark-plan' },
      { label: 'Memory Card: Matthew 11:28', href: '#memory-card' },
      { label: 'Playlist: The Great Reunion (quiet)', href: 'https://open.spotify.com/artist/4AFA0ADp9dugRrRY3RjbIJ', target: '_blank' },
      { label: 'Playlist: Lost Boy Found (drive)', href: 'https://open.spotify.com/artist/5blMhZSDPm29S3kPXQceQc', target: '_blank' },
      { label: 'Playlist: Sprinkld (focus)', href: 'https://open.spotify.com/artist/3gshwRvglY4DfiFqppuY0X', target: '_blank' },
    ],
    memoryCard: {
      title: 'Memory card: Matthew 11:28 (KJV)',
      lines: [
        'Come unto me, all ye that labour and are heavy laden, and I will give you rest.',
      ],
    },
  },
  faq: {
    title: 'FAQ',
    items: [
      {
        q: 'I blew it again. Now what?',
        a: 'Run to Jesus, not from Him. Confess. He is faithful and just to forgive.',
        ref: '1 John 1:9 (KJV)',
      },
      {
        q: 'Do I have to clean up first?',
        a: 'No. Come as you are. He cleans you.',
        ref: 'Titus 3:5 (KJV)',
      },
      {
        q: 'Is this only for church kids?',
        a: "No. It's for the weary. That's you. That's me.",
        ref: 'Matthew 11:28 (KJV)',
      },
      {
        q: 'My faith feels small.',
        a: 'Jesus saves weak people with real trust.',
        ref: 'Mark 9:24 (KJV)',
      },
    ],
  },
  safety: {
    title: 'Safety and human help.',
    lines: [
      "Don't carry this alone.",
    ],
    crisis: {
      text: 'In crisis: Call 988 (U.S.) or your local line now. God cares. We care.',
      phone: '988',
    },
  },
  footer: {
    ref: 'Romans 10:13 (KJV)',
    lines: [
      'For whosoever shall call upon the name of the Lord shall be saved.',
    ],
  },
  credits: {
    label: 'Credit: GotQuestions.org - Salvation',
    href: 'https://www.gotquestions.org/content_salvation.html',
  },
};
